/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Rule_Sets_ItalicInputs */

const en_tables_rule_sets_italic = /** @type {(inputs: Tables_Rule_Sets_ItalicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets Italic`)
};

const de_tables_rule_sets_italic = /** @type {(inputs: Tables_Rule_Sets_ItalicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kursiv`)
};

/**
* | output |
* | --- |
* | "Sets Italic" |
*
* @param {Tables_Rule_Sets_ItalicInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_rule_sets_italic = /** @type {((inputs?: Tables_Rule_Sets_ItalicInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Rule_Sets_ItalicInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_rule_sets_italic(inputs)
	return de_tables_rule_sets_italic(inputs)
});